import { Star, Quote } from "lucide-react";
import { REVIEWS, TRUST } from "../data/site";

export default function PatientReviews({ headingTag: Tag = "h3" }) {
  // Duplicate for seamless marquee
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="section-pad border-y border-black/10 bg-[#0a0a0a] text-white overflow-hidden"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="overline !text-[#7ec3e6]">Patient Reviews</div>
            <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              {TRUST.reviews} verified Google Reviews from Varanasi.
            </Tag>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row sm:items-end gap-6 lg:justify-end">
            <div>
              <div className="flex">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 fill-[#F5B400] text-[#F5B400]"
                  />
                ))}
              </div>
              <div className="mt-3 text-[12px] tracking-[0.18em] uppercase text-white/55 font-semibold">
                Google · Verified
              </div>
            </div>
            <div className="font-serif-display text-6xl md:text-7xl leading-none">
              {TRUST.rating}
              <span className="text-2xl align-top text-white/60">/5</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />

        <div className="flex gap-5 marquee-track w-max">
          {loop.map((r, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="w-[340px] sm:w-[400px] shrink-0 border border-white/10 rounded-[6px] p-7 bg-white/[0.03]"
            >
              <Quote className="h-6 w-6 text-[#7ec3e6]" />
              <p className="mt-5 text-[15px] leading-relaxed text-white/85">
                {r.text}
              </p>
              <div className="mt-6 flex items-center justify-between pt-5 border-t border-white/10">
                <div>
                  <div className="font-semibold">{r.name}</div>
                  <div className="text-[12px] text-white/55">{r.location}</div>
                </div>
                <div className="flex">
                  {Array.from({ length: r.rating }).map((_, j) => (
                    <Star
                      key={j}
                      className="h-3.5 w-3.5 fill-[#F5B400] text-[#F5B400]"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
